
import { useEffect, useRef } from 'react';
import Header from '@/components/Header';
import Hero from '@/components/Hero';
import About from '@/components/About';
import Partners from '@/components/Partners';
import Services from '@/components/Services';
import Contact from '@/components/Contact';
import Footer from '@/components/Footer';

const Index = () => {
  const observerRef = useRef<IntersectionObserver | null>(null);
  
  useEffect(() => {
    // Set up scroll animations for elements with reveal-on-scroll class
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
            // Once activated, we don't need to observe it anymore
            observerRef.current?.unobserve(entry.target);
          }
        });
      },
      {
        root: null,
        rootMargin: '20px 0px',
        threshold: 0.01,
      }
    );

    // Select all elements with the class and observe them
    const elements = document.querySelectorAll('.reveal-on-scroll');
    elements.forEach((el) => observerRef.current?.observe(el));

    // Cleanup
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-light">
      <Header />
      
      {/* Add significant padding-top to account for fixed header */}
      <div className="pt-16 md:pt-20 lg:pt-24">
        <Hero />
      </div>
      
      {/* Apply the apple-section class to create full-height sections with scroll effects */}
      <div className="apple-section min-h-auto">
        <div className="reveal-on-scroll">
          <About />
        </div>
      </div>
      
      {/* Partners section with proper spacing */}
      <div className="min-h-0 py-2 my-0">
        <div className="reveal-on-scroll">
          <Partners />
        </div>
      </div>
      
      <div className="apple-section">
        <div className="reveal-on-scroll">
          <Services />
        </div>
      </div>
      
      <div className="apple-section">
        <div className="reveal-on-scroll">
          <Contact />
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Index;
